import React, { Suspense, useEffect } from 'react';
import './App.css';
import {
  BrowserRouter as BR,
  Routes,
  Route
} from 'react-router-dom'

import ROUTES from './registerRoutes'

import NotFoundPage from './pages/NotFoundPage'

import SOCKET from './utilities/socket.io'
import { parseJwt } from './utilities/parseJwt';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';


function App() {
  const user = parseJwt()
  const [showWarningBalance, setShowWarningBalance] = useState(user?.bie === undefined ? false : !user.bie)
  const loading = (
    <h6 className='text-center'>Loading ...</h6>
  )


  useEffect(() => {
    function handleConnect() {
      console.debug('SERVER CONNECTED')
    }

    function handleDisconnected() {
      console.debug('SERVER DISCONNECTED')
    }

    SOCKET.on('connect', handleConnect)
    SOCKET.on('disconnect', handleDisconnected)

    return () => {
      SOCKET.off('connect', handleConnect)
      SOCKET.off('disconnect', handleDisconnected)
    }
  }, [])

  useEffect(() => {
    SOCKET.connect()

    return () => {
      SOCKET.disconnect()
    }
  }, [])

  return (
    <BR>
      <Modal centered show={showWarningBalance} onHide={() => setShowWarningBalance(!showWarningBalance)}>
        <Modal.Header closeButton>
          <Modal.Title><span className='text-danger'>PERHATIAN!</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <center className='text-danger'>
            Saldo anda saat ini dibawah paket yang terdaftar, silahkan top up untuk bisa melakukan manajemen konten anda dengan normal.
          </center>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShowWarningBalance(!showWarningBalance)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Routes>
        {
          ROUTES.map((d, i) => {
            return (
              <Route
                key={i}
                path={d.path}
                element={
                  <Suspense fallback={loading}>
                    {d.element}
                  </Suspense>
                }
              />
            )
          })
        }
        <Route
          path="*"
          element={
            <Suspense fallback={loading}>
              <NotFoundPage />
            </Suspense>
          }
        />
      </Routes>
    </BR>
  );
}

export default App;
